var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row vh-100"},[_c('div',{staticClass:"col-md-6 d-md-flex align-items-md-center"},[_c('img',{staticClass:"img-fluid img-visibility",attrs:{"src":require('@/assets/img/login.jpg')}})]),_c('LoginForm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }